'use es6';

export const ECOMMERCE = 'ECOMMERCE';